export const shouldNotSignedInRoutes = ['Login', 'ForgotPassword', 'ResetPassword', 'Signup'];
export const publicRoutes = ['PrivacyPolicy', 'PrivacyPolicyEn', 'TermsOfUse', 'TermsOfUseEn'];